export default class extends Controller {

  close(event) {
    event && event.preventDefault()
    App.SlideOut.close({ element: this.element })
  }
}



// WEBPACK FOOTER //
// ./app/components/slide_outs/assets/javascript/slide-outs-close-link-controller.js